import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { FaCheckCircle, FaCalendarAlt, FaClock, FaUsers } from "react-icons/fa";
import { registrationService } from "../services/firebase";
import { formatDateIsrael } from "../utils/dateUtils";
import "./ThankYou.css";

const ThankYou: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [registration, setRegistration] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const loadRegistration = async () => {
      const registrationId = searchParams.get("registrationId");
      if (registrationId) {
        try {
          const data = await registrationService.getById(registrationId);
          setRegistration(data);
        } catch (error) {
                  } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    loadRegistration();
  }, [searchParams]);

  const formatDate = formatDateIsrael;

  return (
    <div className="page-thank-you-container">
      <div className="icon-container">
        <FaCheckCircle size={80} />
      </div>
      <h1 className="thank-you-title">{t("thankYou")}</h1>
      <p className="message">{t("registrationSuccess")}</p>

      {registration && (
        <div className="registration-summary">
          <h3>פרטי ההרשמה</h3>
          <div className="summary-details">
            <div className="summary-item">
              <FaCalendarAlt />
              <span>תאריך: {formatDate(registration.workshopDate)}</span>
            </div>
            {registration.workshopTime && (
              <div className="summary-item">
                <FaClock />
                <span>שעה: {registration.workshopTime}</span>
              </div>
            )}
            {registration.ticketsCount && registration.ticketsCount > 1 && (
              <div className="summary-item">
                <FaUsers />
                <span>מספר כרטיסים: {registration.ticketsCount}</span>
              </div>
            )}
            <div className="summary-item total">
              <span>סה"כ לתשלום: ₪{registration.totalAmount}</span>
            </div>
          </div>
        </div>
      )}

      <Link className="home-button" to="/">
        {t("backToHome")}
      </Link>
    </div>
  );
};

export default ThankYou;
